import { Link } from '@remix-run/react'
import { Card, CardContent } from '#app/components/ui/card'
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '#app/components/ui/tabs'

interface RelatedCosmeticItem {
	id: string
	name: string
	type: string
	rarity: string
	image: string
	slug: string
}

interface RelatedCosmeticsProps {
	byType: RelatedCosmeticItem[]
	bySeason: RelatedCosmeticItem[]
	bySet: RelatedCosmeticItem[]
}

function CosmeticGrid({ items }: { items: RelatedCosmeticItem[] }) {
	return (
		<div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
			{items.map(item => (
				<Link key={item.id} to={`/cosmetics/${item.slug}`}>
					<Card>
						<CardContent className="p-4">
							<img
								src={item.image}
								alt={item.name}
								className="mb-2 h-32 w-full object-cover"
							/>
							<h3 className="text-sm font-semibold">{item.name}</h3>
							<p className="text-xs text-gray-500">{item.type}</p>
							<p className="text-xs text-gray-500">{item.rarity}</p>
						</CardContent>
					</Card>
				</Link>
			))}
		</div>
	)
}

export function RelatedCosmetics({
	byType,
	bySeason,
	bySet,
}: RelatedCosmeticsProps) {
	return (
		<div className="mt-12">
			<h2 className="mb-4 text-2xl font-bold">Related</h2>
			<Tabs defaultValue="type">
				<TabsList>
					<TabsTrigger value="type">By Type</TabsTrigger>
					<TabsTrigger value="season">By Season</TabsTrigger>
					<TabsTrigger value="set">By Set</TabsTrigger>
				</TabsList>
				<TabsContent value="type">
					<CosmeticGrid items={byType} />
				</TabsContent>
				<TabsContent value="season">
					<CosmeticGrid items={bySeason} />
				</TabsContent>
				<TabsContent value="set">
					<CosmeticGrid items={bySet} />
				</TabsContent>
			</Tabs>
		</div>
	)
}
